import React, { ComponentProps } from 'react';
import { useAppContext } from '../../contexts/AppContext/AppContext';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { RssFeedInteractions } from './partials/RssFeedInteractions';
import { RssFeedViewProps } from './RssFeed.types';
import { RssFeedDefaultView } from './views/RssFeedDefaultView';

function RssFeed({ views, activeView }: RssFeedViewProps) {
  const { editModeInfo } = useAppContext();

  return editModeInfo.active ? (
    <RssFeedInteractions views={views} activeView={activeView} />
  ) : (
    <RssFeedDefaultView {...views.default} />
  );
}

export const RssFeedBlock = asFetchableBlock(RssFeed, BlockType.rssfeed);
export type RssFeedBlock = ComponentProps<typeof RssFeedBlock>;
